/* eslint-disable react-refresh/only-export-components */
import React, { createContext, useCallback, useContext, useMemo, useState } from "react"
import { ResellerProfile } from "../hooks/Reseller/useGetResellerProfile"

interface ResellerContextProps {
  resellerProfile: ResellerProfile | null
  setResellerProfile: (profile: ResellerProfile | null) => void
}

const ResellerContext = createContext<ResellerContextProps | undefined>(undefined)

export const ResellerProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [resellerProfile, setResellerProfileState] = useState<ResellerProfile | null>(() => {
    const stored = localStorage.getItem("resellerProfile")

    return stored ? (JSON.parse(stored) as ResellerProfile) : null
  })

  const setResellerProfile = useCallback((profile: ResellerProfile | null) => {
    setResellerProfileState(profile)

    if (profile) {
      localStorage.setItem("resellerProfile", JSON.stringify(profile))
    } else {
      localStorage.removeItem("resellerProfile")
    }
  }, [])

  const value = useMemo(() => ({ resellerProfile, setResellerProfile }), [resellerProfile, setResellerProfile])

  return <ResellerContext.Provider value={value}>{children}</ResellerContext.Provider>
}

export const useResellerLogged = () => {
  const context = useContext(ResellerContext)

  if (!context) {
    throw new Error("useResellerLogged deve ser usado dentro de um ResellerProvider")
  }

  return context
}
